import React, { useMemo } from 'react'
import { Popup } from 'antd-mobile'
import ReactMarkdown from 'react-markdown'

function SleepAnalysisModal({ visible, onClose, sleep_analysis = '' }) {
  const formattedSleepAnalysis = useMemo(() => {
    const headers = [
      'What\'s Working Well',
      'Areas for Attention',
      'Action Plan'
    ]
    return headers.reduce((text, header) => {
      const regex = new RegExp(header, 'g')
      return text.replace(regex, `**${header}**`)
    }, sleep_analysis)
  }, [sleep_analysis])

  return (
    <Popup
      visible={visible}
      onMaskClick={onClose}
      onClose={onClose}
      position="bottom"
      bodyClassName="modal-popup"
    >
      <div className="modal-content">
        <header
          className="modal-header-wrapper"
          style={{ marginBottom: '26px' }}
        >
          <div className="modal-header" style={{ padding: '5px 0 2px' }}>
            <h2>Sleep Analysis</h2>
            <button
              onClick={onClose}
              className="modal-close-btn"
              aria-label="Close"
            >
              Close
            </button>
          </div>
        </header>

        <section className="exercise-container sleep-analysis-container">
          <ReactMarkdown>{formattedSleepAnalysis}</ReactMarkdown>
        </section>
      </div>
    </Popup>
  )
}

export default SleepAnalysisModal
